$(document).ready(function() {
  autosize($("textarea"));
});
